import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function BackToWrestler({ className = "", testId = "back-to-wrestler", style }) {
  const nav = useNavigate();
  const wid = useLocation().state?.fromWrestler;
  const go = () => (wid ? nav(`/wrestler/${wid}`) : nav(-1));
  return (
    <button data-testid={testId} onClick={go} style={style}
            className={`group inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#0A051A]/80 backdrop-blur border-2 border-[#00F0FF]/60 text-[#00F0FF] font-heading text-xs uppercase tracking-widest shadow-[0_0_12px_rgba(0,240,255,0.35)] transition-[background-color,box-shadow,transform] hover:bg-[#00F0FF]/15 hover:shadow-[0_0_18px_rgba(0,240,255,0.6)] active:scale-95 ${className}`}>
      <ArrowLeft size="1.25em" strokeWidth={3} className="transition-transform group-hover:-translate-x-1" /> Back
    </button>
  );
}
